
import Api from '@/utils/api';
import MHeader from '../Header/Header.vue';
import dateFormat from 'vux/src/tools/date/format.js'
import Popup from 'vux/src/components/popup/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Radio from 'vux/src/components/radio/index.vue'

export default {
components: {
MHeader,
Popup,
ViewBox,
Group,
XTextarea,
Actionsheet,
Radio
},
data() {
return {
order: {},
showPayList: false,
payMethodList: {
wxpay: '微信支付',
alipay: '支付宝付款'
},
payingOrderId: ""
}
},
methods: {
loadOrder() {
Api.getOrder(this.$route.params.tid)
.then((resp) => {
if(resp && resp.data) {
this.order = resp.data
}
})
},
totalCount(order) {
let count = 0
_.forEach(order.products, (product) => {
count += product.quantity
})
return count
},
paySelect(orderId, index) {
this.payingOrderId = orderId
this.showPayList = true
},
toPay(payMethod) {
var that = this
if (payMethod == 'alipay') {
location.href = '/#/pay?payMethod=alipay&payingOrderId='+this.payingOrderId
} else if (navigator.userAgent.match('MicroMessenger')) {
Api.wxPay(this.payingOrderId)
.then(res => {
WeixinJSBridge.invoke("getBrandWCPayRequest", res.data, function (res) {
if (res.err_msg == 'get_brand_wcpay_request:ok') {
that.$store.commit('updateToast', {
show: true,
text: '付款成功'
});
that.loadOrder()
} else {
that.$store.commit('updateToast', {
show: true,
text: '付款失败请重新支付'
});
}
});
})
} else {
location.href = '/#/pay?payMethod=wxh5pay&payingOrderId='+this.payingOrderId
}
},
cancelOrder(orderId) {
var that = this
this.$vux.confirm.show({
title: '提示',
content: '是否取消订单',
onConfirm() {
Api.orderCancel(orderId)
.then(res=> {
that.$store.commit('updateToast', {
show: true,
text: '取消订单成功'
});
that.$router.replace({
name: 'orderList'
})
})
}
})
},
refundOrder(orderId) {
var that = this
this.$vux.confirm.show({
title: '提示',
content: '是否确认申请退款',
onConfirm() {
Api.refundOrder(orderId)
.then(res=> {
that.$store.commit('updateToast', {
show: true,
text: '提交退款申请成功, 等待确认'
});
that.loadList()
})
}
})
},
expressInfo(orderId) {
this.$router.push({
name: 'courierInfo',
params: {
tid: orderId
}
})
}
},
created() {
this.loadOrder()
},
computed: {
},
filters: {
refundText(val) {
switch (val) {
case "REFUNDING":
return '退款中'
case "WAIT_SELLER_AGREE":
return '售后处理中'
default:
return "申请退款"
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/OrderList/OrderDetail.vue